module.exports = __webpack_public_path__ + "static/img/b4.29e1162.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/b4.png
// module id = Wovy
// module chunks = 0